import React, { useEffect, useState } from "react";

/**
 * Typewriter animates an array of styled segments character-by-character
 * while preserving inline styles (e.g., colored spans).
 *
 * segments: [{ text: "Hello ", className: "text-foreground" }, { text: "world", className: "text-brand-blue" }]
 */
export default function Typewriter({ segments, speed = 45, startDelay = 200, cursor = true }) {
  const total = segments.reduce((n, s) => n + s.text.length, 0);
  const [shown, setShown] = useState(0);

  useEffect(() => {
    let t;
    const start = setTimeout(() => {
      t = setInterval(() => {
        setShown((s) => {
          if (s >= total) {
            clearInterval(t);
            return s;
          }
          return s + 1;
        });
      }, speed);
    }, startDelay);
    return () => { clearTimeout(start); clearInterval(t); };
  }, [total, speed, startDelay]);

  let remaining = shown;
  const done = shown >= total;
  return (
    <>
      {segments.map((seg, i) => {
        const take = Math.max(0, Math.min(remaining, seg.text.length));
        remaining -= take;
        const visible = seg.text.slice(0, take);
        return (
          <span key={i} className={seg.className}>
            {visible}
          </span>
        );
      })}
      {cursor && (
        <span
          aria-hidden
          className={`inline-block w-[3px] h-[0.85em] align-baseline -mb-1 ml-1 bg-brand-blue ${done ? "animate-pulse" : ""}`}
          style={{ animation: done ? "blink 0.9s steps(2) infinite" : "none" }}
        />
      )}
      <style>{`@keyframes blink { 0%,49% { opacity: 1 } 50%,100% { opacity: 0 } }`}</style>
    </>
  );
}
